const colors = ["#3d5a80", "#98c1d9", "#ff5400", "#d90429", "#fec601", "#008000", "#7b2cbf", "#0cce6b", "#0e7c7b", "#ffc857", "#40a944"];
export const ColorizedAvatars = (text) => {
  const charCodes = text
    .split('')
    .map(char => char.charCodeAt(0))
    .join('');
  const number = parseInt(charCodes, 10);
  return colors[number % colors.length];
}
